var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path15, _path16, _rect9, _rect10, _rect11, _ellipse, _ellipse2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGreekBuildings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 919,
    height: 623,
    viewBox: "0 0 919 623",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.428 365C157.428 364.905 157.429 364.81 157.429 364.714C157.429 329.526 128.903 301 93.7143 301C58.5259 301 30 329.526 30 364.714C30 364.81 30.0002 364.905 30.0006 365H157.428Z",
    fill: "#1674B4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.428 300.767C105.429 300.749 105.429 300.732 105.429 300.714C105.429 294.245 100.184 289 93.7143 289C87.2447 289 82 294.245 82 300.714C82 300.732 82 300.749 82.0001 300.767H105.428Z",
    fill: "#1674B4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M590.999 186.78C591 186.687 591 186.593 591 186.5C591 151.982 563.018 124 528.5 124C493.982 124 466 151.982 466 186.5C466 186.593 466 186.687 466.001 186.78H590.999Z",
    fill: "#1674B4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M888.946 54.6904C888.946 54.6091 888.947 54.5278 888.947 54.4464C888.947 24.3765 864.57 0 834.5 0C804.43 0 780.054 24.3765 780.054 54.4464C780.054 54.5278 780.054 54.6091 780.054 54.6904H888.946Z",
    fill: "#1674B4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M895 55H774V119H770V169H745L696 198H628V305H603V259H598V187H462V259H457V305H430V375H225V504H216V584.544H172V512H170.204C172.669 504.275 174 496.043 174 487.5C174 472.674 169.992 458.784 163 446.854V365H26V443.619C17.7778 456.241 13 471.313 13 487.5C13 496.043 14.3307 504.275 16.7961 512H16V584L0 623H16H216H919V584.544V504V375V198V169H898V119H895V55Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35 386.5C35 378.492 41.4919 372 49.5 372C57.5081 372 64 378.492 64 386.5V442H35V386.5Z",
    fill: "#1674B4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M250 437.5C250 428.94 256.94 422 265.5 422C274.06 422 281 428.94 281 437.5V506H250V437.5Z",
    fill: "#1674B4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M475 220.5C475 215.806 478.806 212 483.5 212C488.194 212 492 215.806 492 220.5V260H475V220.5Z",
    fill: "#1674B4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79 386.5C79 378.492 85.4919 372 93.5 372C101.508 372 108 378.492 108 386.5V442H79V386.5Z",
    fill: "#1674B4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M412 437C412 428.716 418.716 422 427 422C435.284 422 442 428.716 442 437V506H412V437Z",
    fill: "#1674B4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M567 220.5C567 215.806 570.806 212 575.5 212C580.194 212 584 215.806 584 220.5V260H567V220.5Z",
    fill: "#1674B4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M123 386.5C123 378.492 129.492 372 137.5 372C145.508 372 152 378.492 152 386.5V442H123V386.5Z",
    fill: "#1674B4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M331 437.5C331 428.94 337.94 422 346.5 422C355.06 422 362 428.94 362 437.5V506H331V437.5Z",
    fill: "#1674B4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M522 220.5C522 215.806 525.806 212 530.5 212C535.194 212 539 215.806 539 220.5V260H522V220.5Z",
    fill: "#1674B4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 780,
    y: 132,
    width: 10,
    height: 17,
    fill: "#1674B4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 805,
    y: 132,
    width: 10,
    height: 17,
    fill: "#1674B4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 830,
    y: 132,
    width: 10,
    height: 17,
    fill: "#1674B4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 820,
    y: 86,
    width: 28,
    height: 33,
    fill: "#1674B4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 852,
    y: 86,
    width: 19,
    height: 33,
    fill: "#1674B4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 797,
    y: 86,
    width: 19,
    height: 33,
    fill: "#1674B4"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 855,
    y: 132,
    width: 10,
    height: 17,
    fill: "#1674B4"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 881,
    y: 132,
    width: 10,
    height: 17,
    fill: "#1674B4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M848 81.5068C848 81.4867 848 81.4666 848 81.4464C848 74.0202 841.732 68 834 68C826.268 68 820 74.0202 820 81.4464C820 81.4666 820 81.4867 820 81.5068H848Z",
    fill: "#1674B4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M457.998 375C457.999 374.833 458 374.667 458 374.5C458 312.92 408.079 263 346.5 263C284.92 263 235 312.92 235 374.5C235 374.667 235 374.833 235.001 375H457.998Z",
    fill: "#1674B4"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 527,
    y: 113,
    width: 4,
    height: 16,
    rx: 2,
    fill: "#1674B4"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 242,
    y: 319.152,
    width: 4,
    height: 16,
    rx: 2,
    transform: "rotate(-52 242 319.152)",
    fill: "#1674B4"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 447.608,
    y: 316,
    width: 4,
    height: 16,
    rx: 2,
    transform: "rotate(52 447.608 316)",
    fill: "#1674B4"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.5,
    cy: 502.5,
    rx: 10.5,
    ry: 12.5,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 165.5,
    cy: 502.5,
    rx: 10.5,
    ry: 12.5,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreekBuildings);
export default __webpack_public_path__ + "static/media/greek-buildings.b8eac0f95ea4b019867f62dbfe746428.svg";
export { ForwardRef as ReactComponent };